import { glassWall, glassWallPriceService } from './glassWallPriceService';
class glassPrice {
    public price: number;
    public glassWallDef: glassWall;
    constructor(price: number, glassWallDef: glassWall) {
        this.price = price;
        this.glassWallDef = glassWallDef;
    }
}

class glassWallPriceStore {
    cache = [];
    public equalityOperator = this.equals;
    public priceService = new glassWallPriceService();
    public getPriceAsync(glassWall: glassWall) {
        let existingPrice = this.cache.find(g => this.equalityOperator(glassWall, g.glassWallDef));
        if (existingPrice) {
            return new Promise((resolve) => resolve(existingPrice.price));
        }
        else {
            return this.priceService.getPriceAsync(glassWall).then((price) => {
                this.cache.push(new glassPrice(price, glassWall));
                return price;
            });       
        }
    }
    private equals(a: glassWall, b: glassWall) {
        return a.glassWallType == b.glassWallType &&
            a.doorHeight == b.doorHeight &&
            a.doorWidth == b.doorWidth &&
            a.material == b.material &&
            this.sameUpGlass(a, b) &&
            this.sameLeftSideGlass(a, b) &&
            this.sameRightSideGlass(a, b);          
    }
    sameLeftSideGlass(a: glassWall, b: glassWall)
    {
        return (a.leftSideGlassEnabled == false &&  b.leftSideGlassEnabled == false) ||
            (a.leftSideGlassHeight == b.leftSideGlassHeight && a.leftSideGlassWidth == b.leftSideGlassWidth && a.leftSideGlassEnabled == b.leftSideGlassEnabled);
    }
    sameRightSideGlass(a: glassWall, b: glassWall) {
        return (a.rightSideGlassEnabled == false  && b.rightSideGlassEnabled == false) ||
            (a.rightSideGlassHeight == b.rightSideGlassHeight && a.rightSideGlassWidth == b.rightSideGlassWidth && a.rightSideGlassEnabled == b.rightSideGlassEnabled);
    }
    sameUpGlass(a: glassWall, b: glassWall) {

        return (a.upGlassEnabled == false && b.upGlassEnabled == false) ||
            (a.upGlassHeight == b.upGlassHeight && a.upGlassEnabled == b.upGlassEnabled);    
    }

}
export default glassWallPriceStore;